export default __webpack_public_path__ + "f23479fd76eabb55793fbbd0249f5601.png";